export default __webpack_public_path__ + "static/media/paiGowTablePotrait.ad2794db.webp";